// Anything exported from this file is importable by other in-browser modules.
import { getInitialSaleSeatsRequest,setInitialSaleSetsRequest, setPassengersSeatsSelection, getPassengersSeatsSelection } from './store/seats/seats';
import { getInitialSaleServicesRequest,setInitialSaleServicesRequest, setPassengersServicesSelection, getPassengersServicesSelection, setInsurancePassengersMMB, getInsurancePassengersMMB } from './store/services/services';

export function setISSeatsRequest(data) {
    setInitialSaleSetsRequest(data);
};

export function setISServicesRequest(data) {
    setInitialSaleServicesRequest(data);
};

export function getISSeatsRequest() {
    return getInitialSaleSeatsRequest();
};

export function getISServicesRequest() {
    return getInitialSaleServicesRequest();
};

export function setPassengersSeatsSelectionIS(data) {
    setPassengersSeatsSelection(data);
};

export function getPassengersSeatsSelectionIS() {
    return getPassengersSeatsSelection();
};

export function setPassengersServicesSelectionIS(data) {
    setPassengersServicesSelection(data);
};

export function getPassengersServicesSelectionIS() {
    return getPassengersServicesSelection();
};

export function setInsurancePassengers(data) {
    setInsurancePassengersMMB(data);
};

export function getInsurancePassengers() {
    return getInsurancePassengersMMB();
}